import { NavigateFunction } from 'react-router-dom'
import env from '../config/env'

export const baseUrl = `${window.location.protocol}//${window.location.host}`

export const payUrl = env.PAY_HOST

export const goUrl = env.GO_HOST

const getUrlRedirect = (url: string): string => {
  if (!url.trim().toLowerCase().startsWith('http')) {
    url = `https://${url}`
  }
  return url
}

const redirect = (
  urlRedirect?: string,
  urlDefault?: string,
  navigateDefault?: NavigateFunction
) => {
  if (!urlRedirect || urlRedirect.trim() === '') {
    if (urlDefault && urlDefault.trim() !== '') {
      if (navigateDefault) {
        navigateDefault(urlDefault)
      } else {
        window.location.href = getUrlRedirect(urlDefault)
      }
    }
  } else {
    window.location.href = getUrlRedirect(urlRedirect)
  }
}

const openNewBlank = (url: string) => {
  window.open(url, '_blank', 'noreferrer')
}

const openNewBlankCustomCheckout = (id: string) => {
  openNewBlank(`${env.BUILDER_HOST}/customcheckout/${id}`)
}

const returnCodeString = (code?: string) => {
  if (!code) {
    return ''
  }

  if (code === '404') {
    return '404 Servidor ou método não encontrado'
  }
  if (code === '0') {
    return `Sem Resposta`
  } else if (code.startsWith('1')) {
    return `${code} Informação`
  }
  if (code.startsWith('2')) {
    return `${code} Sucesso`
  }
  if (code.startsWith('3')) {
    return `${code} Redirecionamento`
  }
  if (code.startsWith('4')) {
    return `${code} Erro do Cliente`
  }
  if (code.startsWith('5')) {
    return `${code} Erro do Servidor`
  }

  return code
}

async function copyTextToClipboard(text: string) {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (err) {
      console.error('Erro ao copiar (clipboard API):', err)
    }
  }

  try {
    const textarea = document.createElement('textarea')
    textarea.value = text

    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    textarea.style.left = '-9999px'

    document.body.appendChild(textarea)

    textarea.focus()
    textarea.select()

    const success = document.execCommand('copy')
    document.body.removeChild(textarea)

    return success
  } catch (err) {
    console.error('Erro ao copiar (fallback):', err)
    return false
  }
}

const refreshPage = () => {
  window.location.reload()
}

const Hosts = {
  redirect,
  openNewBlank,
  returnCodeString,
  refreshPage,
  copyTextToClipboard,
  openNewBlankCustomCheckout,
}

export default Hosts
